/**
 * Created by Rain Laansalu on 02.11.2017.
 */

import {apiRequest} from "../js/main";
// let test;

$("#loginform").submit(function (e) {
    e.preventDefault();
    $('#keepMeAlive').val($('#keepMeAlive').is(':checked')?1:0);
    let loginmessage = $('#loginmessages');
    loginmessage.hide();
    loginmessage.html('');
    apiRequest(
        $(this).serialize(),
        function (data) {
            if(data){
                if(data.ajaxGranted===1 && data.runFunction){
                    window.location = data.runFunction;
                }else if(data.ajaxGranted!==1 && data.submitMessage){
                    loginmessage.html(data.submitMessage.loginerror);
                    loginmessage.show();
                }else{
                    console.log(data);
                }
            }
    });
});


$("#midSign").submit(function (e) {
    e.preventDefault();
    let postdata = $(this).serialize();
    let registermessages = $('#registermessages');
    let registersuccess = $('#registersuccess');
    registermessages.hide();
    registermessages.html('');
    let inputs = $("#midSign input");
    inputs.removeClass('inputerror');
    // inputs.prop("disabled", true);


    apiRequest(
        postdata,
        function (data) {
            if(data){
                if(data.verification_code){
                    registersuccess.html(data.verification_code);
                    registersuccess.show();

                    // submittype
                    $('#submittype').val('midauthenticate');
                    postdata = $("#midSign").serialize();
                    $('#submittype').val('midsign');
                    apiRequest(
                        postdata,
                        function (data) {
                            if(data){
                                if(data.success){
                                    window.location=data.url;
                                }else if(data.error === true){
                                    inputs.prop("disabled", false);
                                    registermessages.html(data.errormessage);
                                    registermessages.show();
                                }else{
                                    console.log(data);
                                }
                            }
                        });
                }else if(data.error === true){
                    inputs.prop("disabled", false);
                    // if(data.errormessage){
                    //     data.errorFields.forEach(function (item, index) {
                    //         $('input[name='+item+']').addClass('inputerror');
                    //     });
                    // }
                    // registermessages.html(data.errormessage.join('<br>'));
                    registermessages.html(data.errormessage);
                    registermessages.show();
                }else{
                    console.log(data);
                }
            }
        });
});

$("#joinPlatForm").submit(function (e) {
    e.preventDefault();
    let postdata = $(this).serialize();
    let registermessages = $('#registermessages');
    let registersuccess = $('#registersuccess');
    registermessages.hide();
    registermessages.html('');
    let inputs = $("#joinPlatForm input");
    inputs.removeClass('inputerror');
    inputs.prop("disabled", true);

    apiRequest(
        postdata,
        function (data) {
            if(data){
                if(data.ajaxGranted===1 && data.submittedMessage){
                    registersuccess.html(data.submittedMessage);
                    registersuccess.show();
                }else if(data.ajaxGranted!==1){
                    inputs.prop("disabled", false);
                    if(data.errorFields){
                        data.errorFields.forEach(function (item, index) {
                            $('input[name='+item+']').addClass('inputerror');
                        });
                    }
                    registermessages.html(data.errorMessage.join('<br>'));
                    registermessages.show();
                }else{
                    console.log(data);
                }
            }
        });
});

$("#registerForm_72").submit(function (e) {
    e.preventDefault();
    let postdata = $(this).serialize();

    let emailmessage = $('#passwordmessages');
    emailmessage.hide();
    emailmessage.html('');
    let inputs = $("#registerForm_72 input");
    inputs.prop("disabled", true);
    apiRequest(
        postdata,
        function (data) {
            if(data){
                if(data.ajaxGranted===1 && data.submitMessage){
                    emailmessage.html(data.submitMessage);
                    emailmessage.slideDown(500);
                    $("#registerForm_72").slideUp(500);
                }else{
                    inputs.prop("disabled", false);
                    emailmessage.html(data.errorMessage);
                    emailmessage.slideDown(500);
                }
            }
        });
});

$("#postMail_75").submit(function (e) {
    e.preventDefault();
    let postdata = $(this).serialize();
    $(this).slideUp(500, function () {
        let emailmessage = $('#emailmessage');
        emailmessage.hide();
        emailmessage.html('');
        let inputs = $("#postMail_75 input");
        inputs.prop("disabled", true);
        apiRequest(
            postdata,
            function (data) {
                if(data){
                    if(data.ajaxGranted===1 && data.submitMessage){
                        emailmessage.html(data.submitMessage);
                        emailmessage.slideDown(500);
                    }else{
                        console.log(data);
                    }
                }
            });

    });
});

$("#idajax").click(function(){

    // var span = $(this).find('span');
    // var text = span.html();
    // span.html("Oota...");

    let loginmessage = $('#loginmessages');
    loginmessage.html('Autentimine...');
    loginmessage.show();
    $.ajax({
        dataType: "json",
        url: "./idtest/OCSP_PHP_client/test.php?export=1",
        statusCode: {
            404: function() {
                loginmessage.html('Autentimine ebaõnnestus! 404');
                // displayLoginError("page not found")
                // span.removeClass( "fa fa-spinner fa-spin").html(text);
            }
        },
        success: function(data){
            if(data.success){
                window.location=data.url;
            }
            return;
        }
    }).done(function(data) {
        console.log(data);
        // span.removeClass( "fa fa-spinner fa-spin" ).html(text);
    }).fail(function(data) {
        loginmessage.html('Autentimine ebaõnnestus!');
        // displayLoginError("Sisselogimine ebaõnnestus!")
        // span.removeClass( "fa fa-spinner fa-spin" ).html(text);
    });
});

$("#midajax").click(function () {
    $( "#loginform" ).hide();
    $( "#midloginform" ).show();

    return;

    let loginmessage = $('#loginmessages');
    loginmessage.hide();
    loginmessage.html('');
    loginmessage.html('Autentimine ebaõnnestus!');
    loginmessage.show();
    // apiRequest(
    //     $(this).serialize(),
    //     function (data) {
    //         if(data){
    //             if(data.ajaxGranted===1 && data.runFunction){
    //                 window.location = data.runFunction;
    //             }else if(data.ajaxGranted!==1 && data.submitMessage){
    //                 loginmessage.html(data.submitMessage.loginerror);
    //                 loginmessage.show();
    //             }else{
    //                 console.log(data);
    //             }
    //         }
    // });
});

// function displayLoginError(error){
//     $("#text_email").popover({placement : 'top', content: '<span style="font-weight:bold;color:red;">'+error+'</span>',  html:true });
//     $("#text_email").popover("show");
// }

// $('[data-toggle="submitloginform"]').each(function (index, e) {
//     $(this).on("click", function(){
//         console.log(this);
//     });
// });
//
// var errorClassName='input-error';
// var errorTrClassName='row-error';
//
// var jsLogin = new function(){
//     this.messageDIV_visible=false;
//     this.messageDIV_object=null;
//     this.ajax;
//     this.submitRegister=function(cElem,cFrom){
//         this.cacheBtn=cElem;
//         this.cacheBtn.disabled=true;
//         cElem.value=cElem.getAttribute('progressvalue');
//         //var inps=this.cacheBtn.parentNode.parentNode.parentNode.parentNode.getElementsByTagName('INPUT');
//         //inps[0].style.borderColor='';
//         //inps[1].style.borderColor='';
//         this.setAjax(cFrom);
//         this.checkFields();
//         if(this.messageDIV_visible==true){
//             this.form.removeChild(this.messageDIV_object);
//             this.messageDIV_visible=false;
//         }
//         this.ajax.runAjax('submitRegister','','&export=1','jsLogin.ajaxRegisterSubmitted')
//     }
//
//     this.ajaxRegisterSubmitted=function(xmlHttpReq){
//         if (xmlHttpReq.readyState == 4 && xmlHttpReq.status == 200) {
//             var returnText=xmlHttpReq.responseText;
//             console.log(returnText);
//             if($(this.cacheBtn).attr('admin')) alert(returnText);
//             var tmpXML=xmlHttpReq.responseXML;
//             var XML_mainParams=tmpXML.getElementsByTagName('submitFormTags')[0];
//             var XML_granted=XML_getNodeValue('ajaxGranted',XML_mainParams);
//             var XML_linkTo=XML_getNodeValue('runFunction',XML_mainParams);
//             var XML_errorFlds=XML_getNodeValue('errorFields',XML_mainParams);
//             var XML_errorMsgs=XML_getNodeValue('errorMessage',XML_mainParams);
//             var XML_okMsgs=XML_getNodeValue('submittedMessage',XML_mainParams);
//             if(XML_granted==1){
//                 this.showMessage(XML_okMsgs,1);
//             }else{
//                 this.showMessage(XML_errorMsgs,0);
//                 this.checkFields(XML_errorFlds);
//             }
//             this.cacheBtn.disabled=false;
//             this.cacheBtn.value=this.cacheBtn.getAttribute('mainvalue');
//         }
//     }
//
//     this.checkFields=function(cFrmAjax){
//         if(cFrmAjax==null) cFrmAjax="";
//         else cFrmAjax=","+cFrmAjax+",";
//         var inps=this.form.getElementsByTagName('INPUT');
//         $('input.'+errorClassName).removeClass(errorClassName);
//         $('tr.'+errorTrClassName).removeClass(errorTrClassName);
//         for(var ii=0; ii<inps.length; ii++){
//             if(cFrmAjax.indexOf(","+inps[ii].name+",")!=-1){
//                 $(inps[ii]).addClass(errorClassName);
//                 $(inps[ii]).closest('tr').addClass(errorTrClassName);
//             }
//         }
//     }
//
//     this.showMessage=function(cMsg,cMsgT){
//         /*if(cMsgT==1){
//             this.form.innerHTML='<div class="submitMessageDIV">'+cMsg+'</div>';
//         }else{
//             var nextElem=this.form.getElementsByTagName('INPUT')[0];
//             var msgDiv=document.createElement('DIV');
//             msgDiv.className=(cMsgT==2 ? 'submitMessageDIV' : 'errorMessageDIV');
//             msgDiv.innerHTML=cMsg;
//             this.form.insertBefore(msgDiv,nextElem);
//             this.messageDIV_visible=true;
//             this.messageDIV_object=msgDiv;
//         }*/
//
//         if(cMsgT==1){
//             this.form.innerHTML='<div class="alert alert-success" style="display:none;"><strong>'+cMsg+'</strong></div>';
//             $('.alert-success').fadeIn();
//         }else{
//             var nextElem=this.form.getElementsByTagName('INPUT')[0];
//             var msgDiv=document.createElement('DIV');
//             msgDiv.className=(cMsgT==2 ? 'alert alert-success ' : 'alert alert-danger ');
//             $(msgDiv).hide();
//             msgDiv.innerHTML='<strong>'+cMsg+'</strong>';
//             this.form.insertBefore(msgDiv,nextElem);
//             $(msgDiv).fadeIn();
//             this.messageDIV_visible=true;
//             this.messageDIV_object=msgDiv;
//         }
//
//     }
//
//     this.submitLogin=function(cElem,cFrom){
//         $('#keepMeAlive').val($('#keepMeAlive').is(':checked')?1:0);
//         this.cacheBtn=cElem;
//         this.cacheBtn.disabled=true;
//         var inps=this.cacheBtn.parentNode.parentNode.parentNode.parentNode.getElementsByTagName('INPUT');
//         inps[0].style.borderColor='';
//         inps[1].style.borderColor='';
//         this.setAjax(cFrom);
//         this.ajax.runAjax('submitLogin','','&export=1','jsLogin.ajaxSubmitted')
//     }
//
//     this.ajaxSubmitted=function(xmlHttpReq){
//         if (xmlHttpReq.readyState == 4 && xmlHttpReq.status == 200) {
//             var returnText=xmlHttpReq.responseText;
//             //alert(returnText);
//             //$("#text_email").popover("hide");
//             console.log(xmlHttpReq);
//             var tmpXML=xmlHttpReq.responseXML;
//             var XML_mainParams=tmpXML.getElementsByTagName('submitFormTags')[0];
//             var XML_granted=XML_getNodeValue('ajaxGranted',XML_mainParams);
//             var XML_linkTo=XML_getNodeValue('runFunction',XML_mainParams);
//             var XML_msg=XML_getNodeValue('submitMessage',XML_mainParams);
//             if(XML_granted==1){
//                 window.location=XML_linkTo;
//                 return;
//             }
//             //$('#login_button').popover({html:XML_msg,template:''});
//             if($('div.popover').length==0){
//                 $("#text_email").popover({placement : 'top', content: '<span style="font-weight:bold;color:red;">'+XML_msg+'</span>',  html:true });
//                 $('#text_email').on('hidden.bs.popover', function () {
//                 })
//             }
//             $("#text_email").popover("show");
//             var inps=this.cacheBtn.parentNode.parentNode.parentNode.parentNode.getElementsByTagName('INPUT');
//             inps[0].style.borderColor='#FE4D01';
//             inps[1].style.borderColor='#FE4D01';
//             this.cacheBtn.disabled=false;
//         }
//     }
//
//     this.cacheElements=function(cElem){
//         this.object=cElem;
//         this.row=cElem.parentNode.parentNode;
//         this.tbl=this.row.parentNode.parentNode;
//     }
//
//     this.setAjax=function(cForm){
//         eval("this.form="+cForm+";");
//         this.ajax=new AjaxClassCollection(this.form.action,cForm,'jsLogin.ajax','');
//     }
//
// }



//////////////////
// WEBPACK FOOTER
// ./src/js/login.js
// module id = 13
// module chunks = 0